// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ColoredCard__card___2p6dd{max-width:252px;padding:24px;border-radius:8px;background-repeat:no-repeat;background-position:100% calc(100% + 10px);background-size:100px 100px}.ColoredCard__title___3y8ZW{color:inherit;font-weight:400;font-size:20px;line-height:32px}.ColoredCard__desc___iJ6GU{margin-top:8px}.ColoredCard__button___1QM8H{margin-top:32px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"card": "ColoredCard__card___2p6dd",
	"title": "ColoredCard__title___3y8ZW",
	"desc": "ColoredCard__desc___iJ6GU",
	"button": "ColoredCard__button___1QM8H"
};
module.exports = ___CSS_LOADER_EXPORT___;
